import styled from 'styled-components'

export const Wrapper = styled.div`
    padding-top: 94px;
    padding-bottom: 60px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding-top: 158px;
    }
`

export const Heading = styled.h1`
    text-align: center;
    ${(props) => props.theme.typo.bodyL};
    color: ${(props) => props.theme.color.g600};
    ${(props) => props.theme.fontWeight.bold}

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayXL};
    }
`
